import { defineStore } from 'pinia'

export const useProfileLeadCancelReasonsStore = defineStore('profileLeadCancelReasons', {
  state: () => ({
    list: [] as string[],
    loaded: false,
  }),
  actions: {
    async fetch() {
      if (this.loaded) return

      try {
        const { $api } = useNuxtApp()
        const data = await $api<{ data: string[] }>('/profile/leads/cancel-reasons')
        this.list = data?.data ?? []
        this.loaded = true
      } catch {
        this.loaded = true
      }
    },
  },
})
